<mat-drawer-container>
  <mat-drawer-content>
    <div class="content">
      <!-- Header -->
      <div class="header">
        <button class="sidebar-toggle" mat-icon-button (click)="projectSheetsComponent.drawer.toggle()">
          <mat-icon [svgIcon]="'menu'"></mat-icon>
        </button>
        <!-- Title -->
        <div class="title">
          <h3>{{ projectSheet?.name }}</h3>
        </div>
      </div>

      <iframe
        [src]="projectSheet?.embed_url | safe"
        frameborder="0"
        scrolling="yes"
        seamless="seamless"
        style="display: block; width: 100%; height: calc(100vh - 204px)"
      ></iframe>
    </div>
  </mat-drawer-content>
</mat-drawer-container>
<span #emptyItem></span>
